export default "__VITE_ASSET__266e449a__"